module.exports = __webpack_public_path__ + "img/avatar-89.6728aa0b.png";